function helperStringUpperCase (str) {
  return str.toUpperCase()
}

module.exports = helperStringUpperCase



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperStringUpperCase.js
// module id = 313
// module chunks = 98